import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询所有愿望单列表
export const queryAllFavorites: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setFavorites', { ...state.list, loading: true });
    // const { list, pageNum, pageSize, total } = await $http.post('/view/favorite/all/list', payload);
    const { list, pageNum, pageSize, total } = await $http.post('/v1/design/favorite/list', payload);
    commit('setFavorites', { data: list, pageNum, pageSize, total });
  } catch (e) {
    commit('setFavorites', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询当前企业愿望单列表
export const queryOrgFavorites: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setFavorites', { ...state.list, loading: true });
    // const { list, pageNum, pageSize, total } = await $http.post('/view/favorite/org/list', payload);
    const { list, pageNum, pageSize, total } = await $http.post('/v1/design/favorite/listbyorg', payload);
    commit('setFavorites', { data: list, pageNum, pageSize, total });
  } catch (e) {
    commit('setFavorites', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询愿望单的物料列表(子列表)
export const querySubList: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setSubList', { data: [], loading: true });
    // const res: any = await $http.post('/view/favorite/main/detail', payload);
    const res: any = await $http.post('/v1/design/favorite/detail', payload);
    commit('setSubList', { data: res?.itemPickingLineDtoList });
  } catch (e) {
    commit('setSubList', { data: [] });
  }
};

// 查询组织列表
export const queryOrgs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOrgs', { ...state.orgs, loading: true });
    // const res = await $http.post('/baseinfo/organizations/list', payload);
    const res = await $http.post('/v1/baseinfo/org/list', payload);
    commit('setOrgs', { data: res });
  } catch (e) {
    commit('setOrgs', { data: [] });
  }
};

// 查询用户列表
export const queryUsers: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setUsers', { ...state.users, loading: true });
    // const res = await $http.post('/baseinfo/user/list', payload);
    const res = await $http.post('/v1/baseinfo/user/list', payload);
    commit('setUsers', { data: res });
  } catch (e) {
    commit('setUsers', { data: [] });
  }
};
